module.exports = __webpack_public_path__ + "img/p2-1.fb74cd75.png";